import DocumentTitle from 'react-document-title';
import Header from '../../components/Header';
import React from 'react';

export class MercuryTitle extends React.Component {
  render() {
    const { title, children, showAvatar } = this.props;
    return (
      <>
        <Header showAvatar={showAvatar || false} />
        <DocumentTitle title={title}>{children}</DocumentTitle>;
      </>
    );
  }
}
